exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeholderImgWrap[data-v-0e99476c]{text-align:center;padding:200px}#placeholderImg[data-v-0e99476c]{width:320px;height:260px}.placeholderText[data-v-0e99476c]{padding:20px 0}", ""]);

// exports
